import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'app-geotag-modal',
  templateUrl: './geotag-modal.component.html',
  styleUrls: ['./geotag-modal.component.css']
})
export class GeotagModalComponent implements OnInit {

  @Input() location: any;
  @Input() testId: string;
  @Input() idToken: string;
  @Input() uid: string;
  @Output() updateMap: EventEmitter<any> = new EventEmitter();
  display;
  markerOptions = {
    animation: google.maps.Animation.DROP,
    icon: './assets/icon.png',
    clickable: true
  };
  private markerPicked = false;
  center = {lat: 0, lng: 0};

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    if (this.location.lat !== 0 && this.location.lng !== 0) {
      this.display = new google.maps.LatLng(this.location.lat, this.location.lng);
      this.center = this.display;
    }
  }

  move($event: google.maps.MapMouseEvent) {
    if (!this.markerPicked) {
      this.display = $event.latLng.toJSON();
    }
  }

  mapClick($event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
    if (!this.markerPicked) {
      this.markerPicked = true;
      this.display = $event.latLng.toJSON();
    } else {
      this.markerPicked = false;
    }
  }

  markerClick() {
    if (this.markerPicked) {
      this.markerPicked = false;
    }
  }

  async saveLocation() {
    const deleteData = {
      places: {
        formatted_address: this.location.formatted_address,
        lat: this.location.lat,
        lng: this.location.lng,
        name: this.location.name,
        place_id: this.location.place_id,
        time_created: this.location.time_created
      }
    };

    await this.apiService.deletePlace(deleteData, this.uid, this.idToken);
    const data = {
      places:
        {
          place_id: this.location.place_id,
          name: this.location.name,
          formatted_address: this.location.formatted_address,
          lat: this.display.lat,
          lng: this.display.lng,
          time_created: this.location.time_created
        },
    };
    await this.apiService.saveUserLocation(data, this.uid, this.idToken);

    this.updateMap.emit({
      place_id: this.location.place_id,
      name: this.location.name,
      formatted_address: this.location.formatted_address,
      lat: this.display.lat,
      lng: this.display.lng,
      time_created: this.location.time_created
    });
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.display.lng = position.coords.longitude;
        this.display.lat = position.coords.latitude;
        this.markerPicked = false;
        this.center = this.display;
      });
    } else {
      console.log('No support for geolocation');
    }
  }
}
